import { Outlet } from 'react-router-dom';
import { AuthBrandPanel } from '@/features/auth/components/AuthBrandPanel';
import '../features/auth/LoginPage.css';

export const AuthLayout = () => (
  <main className="auth-shell">
    <AuthBrandPanel />
    <section className="auth-content" aria-label="Sign in to Talentchek">
      <div className="auth-content__form">
        <Outlet />
      </div>
      <footer>Powered by Autochek Africa</footer>
    </section>
  </main>
);
export default AuthLayout;
